import {
  SET_OPEN_VENUES_FOR_BREAKFAST,
  SET_OPEN_VENUES_FOR_DINNER,
} from '../constants/dineAround';
import { getOpenVenuesAcrossTheBreak } from '../../dineAround/dineAroundHelper';
import { dineAroundBreakfastType, dineAroundDinnerType } from '../../dineAround/dineAroundConstants';

const setOpenVenuesForBreakfast = openVenues => ({
  type: SET_OPEN_VENUES_FOR_BREAKFAST,
  openVenues,
});

const setOpenVenuesForDinner = openVenues => ({
  type: SET_OPEN_VENUES_FOR_DINNER,
  openVenues,
});

// eslint-disable-next-line import/prefer-default-export
export const setOpenVenuesAcrossTheBreak = (
  arrivalDate,
  departureDate,
  entertainments,
  dineAroundBreakfastCategory,
  dineAroundDinnerCategory,
) => (dispatch) => {
  const openVenuesForBreakfast = getOpenVenuesAcrossTheBreak(
    arrivalDate,
    departureDate,
    entertainments,
    dineAroundBreakfastCategory,
    dineAroundBreakfastType,
  );

  dispatch(setOpenVenuesForBreakfast(openVenuesForBreakfast));

  const openVenuesForDinner = getOpenVenuesAcrossTheBreak(
    arrivalDate,
    departureDate,
    entertainments,
    dineAroundDinnerCategory,
    dineAroundDinnerType,
  );

  dispatch(setOpenVenuesForDinner(openVenuesForDinner));
};
